import i18n from 'i18next';

/** BCP 47 locale for Intl formatting, following the active UI language. */
export function activeLocale(): string {
  return (i18n.language ?? 'en').startsWith('es') ? 'es-ES' : 'en-GB';
}

export function formatCurrency(amount: number, currency = 'EUR'): string {
  return new Intl.NumberFormat(activeLocale(), { style: 'currency', currency, maximumFractionDigits: 0 }).format(amount);
}

export function formatNumber(value: number, fractionDigits = 0): string {
  return new Intl.NumberFormat(activeLocale(), { maximumFractionDigits: fractionDigits }).format(value);
}

/** "29/09/2026" · "29/09/2026" (day-first in both supported locales). */
export function formatDate(iso: string | Date): string {
  return new Date(iso).toLocaleDateString(activeLocale());
}

/** "09:12" */
export function formatTime(iso: string | Date): string {
  return new Date(iso).toLocaleTimeString(activeLocale(), { hour: '2-digit', minute: '2-digit' });
}
